module.exports = __webpack_public_path__ + "static/media/28.48877e94.jpg";